import { Component, OnInit, Input, Inject, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-addtask',
  templateUrl: './addtask.component.html',
  styleUrls: ['./addtask.component.scss'] 
})

export class AddTaskComponent implements OnInit {

  colors = [
    {
     colname:'#F5D428'     
   },
   {
     colname:'#6FC040'
   },
   {
     colname:'#52A7F9'
    },
    {
      colname:'#EF8F1E'
    },
    {
     colname:'#EC5C58'
    },
    {
      colname:'#B36AE2'
    },
 ]
  @Input() typeIdDrp : number;
  @Output() getCloseCreateTask = new EventEmitter<boolean>();
  @Output() getSaveTask = new EventEmitter<boolean>(); 
  @Output() taskListTaskSaved = new EventEmitter<boolean>();
  @Input() taskId : number;
  @Input() taskListID : number;
  @Input() moduleName : string;
  @Input() name : string;
  @Input() email : string;
  @Input() imageUrl : string;
  @Input() typeId : number;
  @Input() transactionID : number;

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  myTaskForm: FormGroup; 
  folderList: any[] = []; 
  folderId:number=0; 
  OfficeIDList: any=[];
  myOfficeID: number=0;
  showColorPannel = false;
  selectedColor:string = '#a59f9f';
  spinner:boolean=false;

  constructor(private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService,
    private statusConst: StatusConstant, private coreService: CoreService, 
    private toastr: ToastrService) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
    this.currentUser = jwt_decode(token); 
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    let group = {};
    this.myTaskForm = new FormGroup(group);
    this.createFormTask();
  }

  ngOnInit(): void {
    let group = {};
    this.myTaskForm = new FormGroup(group);
    this.createFormTask();  
  }     

  createFormTask(): void {
   this.myTaskForm = this.formBuilder.group({
    title: ['', [Validators.required]],
    description: [''],
    dueDate: [''],
    startDate: [''],
    isInternal:false,
    isDueDateTrigger:false,
   },);
  } 
  
  async SaveTaskDetails(data){
    if(data.dueDate!=''){
      data.dueDate= new Date(data.dueDate.getFullYear(), data.dueDate.getMonth(), data.dueDate.getDate(), data.dueDate.getHours(), data.dueDate.getMinutes() - data.dueDate.getTimezoneOffset()).toISOString();
      //data.dueDate.setDate(data.dueDate.getDate() +1); 
    }
    if(data.startDate!=''){
      data.startDate= new Date(data.startDate.getFullYear(), data.startDate.getMonth(), data.startDate.getDate(), data.startDate.getHours(), data.startDate.getMinutes() - data.startDate.getTimezoneOffset()).toISOString();
      //data.dueDate.setDate(data.dueDate.getDate() +1); 
    }
    if(this.moduleName == "Task"){
        //For Save Task
      if(this.taskId==0 && this.taskListID==0){
       this.SaveTask(data);
        return;
       }
      if(this.taskId==0 && this.taskListID>0){
       this.SaveTaskList(data);
      }
    }else{
      if(this.taskId==0 && this.taskListID==0){
        this.SaveTask3C(data);
         return;
        }
       if(this.taskId==0 && this.taskListID>0){
        this.SaveTaskList3C(data);
       }
    }
   

    // //For Save SubTask
    // if(this.taskId>0 && this.taskListID==0){
    //   this.SaveSubTask(data);
    //   return;
    // }   
  }


  async SaveTask(data){
    if(data.isInternal==false){
      data.isInternal=true;
    }else{
      data.isInternal=false;
    }
    if(data.isDueDateTrigger==true){
      data.isDueDateTrigger=true;
    }else{
      data.isDueDateTrigger=false;
    }
    var ReqModel={
      parentTaskID: 0,
      tasklistID:0,
      title: data.title,
      description: data.description,
      colourCode: this.selectedColor,
      isInternal: data.isInternal,
      isDueDateTrigger:data.isDueDateTrigger,
      dueDate: data.dueDate,
      startDate: data.startDate,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
   // return;
    this.spinner=true;
    this.myTaskForm.markAsPristine();
    const result = await this.coreService.addTask(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false;
      this.close();
      this.myTaskForm.reset();
      this.getSaveTask.emit(false);
      this.toastr.success("Task created successfully.", '', {
        timeOut: 3000,
      });
    }
    else {
      this.spinner=false;
      this.close();
    } 
  }
  

  async SaveTaskList(data){
    if(data.isInternal==false){
      data.isInternal=true;
    }else{
      data.isInternal=false;
    }
    if(data.isDueDateTrigger==true){
      data.isDueDateTrigger=true;
    }else{
      data.isDueDateTrigger=false;
    }
    var ReqModel={
      parentTaskID: 0,
      tasklistID:this.taskListID,
      title: data.title,
      description: data.description,
      colourCode: this.selectedColor,
      isInternal: data.isInternal,
      isDueDateTrigger:data.isDueDateTrigger,
      dueDate: data.dueDate,
      startDate: data.startDate,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
   // return;
    this.spinner=true;
    this.myTaskForm.markAsPristine();
    const result = await this.coreService.addTask(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false;
      this.close();
      this.myTaskForm.reset();
      this.getSaveTask.emit(false);
      this.taskListTaskSaved.emit(true);
      this.toastr.success("Created successfully.", '', {
        timeOut: 3000,
      });
    }
    else {
      this.spinner=false;
      this.close();
    } 
  }


  async SaveTask3C(data){
    if(data.isInternal==false){
      data.isInternal=true;
    }else{
      data.isInternal=false;
    }
    if(data.isDueDateTrigger==true){
      data.isDueDateTrigger=true;
    }else{
      data.isDueDateTrigger=false;
    }
    var ReqModel={
      parentTaskID: 0,
      tasklistID:0,
      title: data.title,
      description: data.description,
      colourCode: this.selectedColor,
      isInternal: data.isInternal,
      isDueDateTrigger:data.isDueDateTrigger,
      dueDate: data.dueDate,
      startDate: data.startDate,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      entityTypeAttached: this.typeId,
      attached3C:{
        taskAttachedEntityID: 0,
        taskID: 0,
        attachedEntityID: this.transactionID,
        attachedEntityRelation: "",
        attachedEntityTitle: "",
        attachedEntityName: this.name,
        attachedEntityEmail: this.email,
        attachedEntityTypeID: this.typeIdDrp,
        imageUrl: this.imageUrl,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        //createdBy: this.currentUser.UID,
      }
    }
   // return;
    this.spinner=true;
    this.myTaskForm.markAsPristine();
    const result = await this.coreService.addTask(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false;
      this.close();
      this.myTaskForm.reset();
      this.getSaveTask.emit(false);
      this.toastr.success("Task created successfully.", '', {
        timeOut: 3000,
      });
    }
    else {
      this.spinner=false;
      this.close();
    } 
  }
  

  async SaveTaskList3C(data){
    if(data.isInternal==false){
      data.isInternal=true;
    }else{
      data.isInternal=false;
    }
    if(data.isDueDateTrigger==true){
      data.isDueDateTrigger=true;
    }else{
      data.isDueDateTrigger=false;
    }
    var ReqModel={
      parentTaskID: 0,
      tasklistID:this.taskListID,
      title: data.title,
      description: data.description,
      colourCode: this.selectedColor,
      isInternal: data.isInternal,
      isDueDateTrigger: data.isDueDateTrigger,
      dueDate: data.dueDate,
      startDate: data.startDate,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      entityTypeAttached: this.typeId,
      attached3C:{
        taskAttachedEntityID: 0,
        taskID: 0,
        attachedEntityID: this.transactionID,         
        attachedEntityName: this.name,
        attachedEntityEmail: this.email,
        attachedEntityTypeID: this.typeIdDrp,
        imageUrl: this.imageUrl,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
      }
    }
   // return;
    this.spinner=true;
    this.myTaskForm.markAsPristine();
    const result = await this.coreService.addTask(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false;
      this.close();
      this.myTaskForm.reset();
      this.getSaveTask.emit(false);
      this.toastr.success("Task List created successfully.", '', {
        timeOut: 3000,
      });
    }
    else {
      this.spinner=false;
      this.close();
    } 
  }

  // async SaveSubTask(data){
  //   var ReqModel={
  //     tasklistID:0,
  //     parentTaskID: this.taskId,
  //     title: data.title,
  //     description: data.description,
  //     colourCode: this.selectedColor,
  //     isInternal: data.isInternal,
  //     dueDate: data.dueDate,
  //     organizationID: Number(this.organizationId),
  //     databaseID: Number(this.databaseId),
  //     userID: this.currentUser.UID,
  //     officeID: this.myOfficeID,
  //     officeIDList: this.OfficeIDList     
  //   }
  //  // return;
  //   this.spinner=true;
  //   this.myTaskForm.markAsPristine();
  //   const result = await this.coreService.addTask(ReqModel).toPromise();
  //   if (result.status === this.statusConst.statusSuccess) {
  //     this.spinner=false;
  //     this.close();
  //     this.myTaskForm.reset();
  //     this.getSaveTask.emit(false);
  //     this.toastr.success("Sub Task created successfully.", '', {
  //       timeOut: 3000,
  //     });
  //   }
  //   else {
  //     this.spinner=false;
  //     this.close();
  //   } 
  // }

  close() {
    this.myTaskForm.reset();
    this.getCloseCreateTask.emit(false);
  } 


  toggleColorSelection(){
    this.showColorPannel = !this.showColorPannel;
  }

  SelectColor(color) {
    this.selectedColor = color;
    this.showColorPannel=false;
  } 
  
}
